import React from "react";
import Link from "next/link";
import classNames from "classnames";

import { apiPath } from "@/helpers/apiPath";
import useRequest from "@/helpers/useRequest";
import { routePath } from "@/helpers/routePath";
import { applicationRoutes } from "@/helpers/applicationRouting";
import Typography from "@/components/Typography";

import styles from "./SearchCategories.module.scss";

export const SearchCategories: React.FC = () => {
  const { data: tags } = useRequest(apiPath.MAIN_TAGS);
  const { data: sponsoredTags } = useRequest(apiPath.SPONSORED_TAGS);
  const { data: popularTags } = useRequest(apiPath.POPULAR_TAGS);

  return (
    <>
      {!!popularTags?.length && (
        <div className={styles.navigation}>
          <Typography variant="h3" component="h6" className={styles.heading}>
            Popularne
          </Typography>

          <div className={classNames(styles.nav, styles.columns)}>
            {popularTags?.map((tag) => (
              <Link
                href={routePath.TAG.href}
                as={applicationRoutes.TAG + tag.slug}
                key={tag.slug}
              >
                <a className={styles.link}>
                  <Typography variant="large" component="span">
                    {tag.title}
                  </Typography>
                </a>
              </Link>
            ))}
          </div>
        </div>
      )}

      <div className={styles.navigation}>
        <Typography variant="h3" component="h6" className={styles.heading}>
          Kategorie
        </Typography>

        <div className={classNames(styles.nav, styles.columns)}>
          {tags?.map((tag) => (
            <Link
              href={routePath.TAG.href}
              as={applicationRoutes.TAG + tag.slug}
              key={tag.slug}
            >
              <a className={styles.link}>
                <Typography variant="large" component="span">
                  {tag.title}
                </Typography>
              </a>
            </Link>
          ))}
        </div>
      </div>

      {!!sponsoredTags?.length && (
        <div className={styles.navigation}>
          <Typography variant="h3" component="h6" className={styles.heading}>
            Sponsorowane
          </Typography>

          <div className={classNames(styles.nav, styles.columns)}>
            {sponsoredTags?.map((tag) => (
              <Link
                href={routePath.TAG.href}
                as={applicationRoutes.TAG + tag.slug}
                key={tag.slug}
              >
                <a className={styles.link}>
                  <Typography variant="large" component="span">
                    {tag.title}
                  </Typography>
                </a>
              </Link>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default SearchCategories;
